import { Dispatch, SetStateAction, useState } from 'react';
import { IComposableDashboardCollectionsContext, IProfileDashboard } from 'wisestep-api';

import { useComposableDashboardCollectionsContext } from './useComposableDashboardCollectionsContext';

const useTagDashboardCollection = (
  profileDashboards: IProfileDashboard[],
  setProfileDashboards: Dispatch<SetStateAction<IProfileDashboard[]>>
) => {
  const { setDashboardCollections } =
    useComposableDashboardCollectionsContext() as Required<IComposableDashboardCollectionsContext>;
  const [openTagDialog, setOpenTagDialog] = useState<boolean>(false);
  const handleTagDashboard = (profileDashboard: IProfileDashboard) => {
    const index = profileDashboards.findIndex(({ id }) => id === profileDashboard.id);
    if (index !== -1) {
      profileDashboards.splice(index, 1, profileDashboard);
      setProfileDashboards([...profileDashboards]);
    } else {
      setProfileDashboards((prev) => [...prev, profileDashboard]);
    }
    setDashboardCollections((prev) => {
      const updatedCollections = prev.map((dashboardCollection) =>
        dashboardCollection.id === profileDashboard.dashboardCollection.id
          ? profileDashboard.dashboardCollection
          : dashboardCollection
      );
      return updatedCollections;
    });
    setOpenTagDialog(false);
  };
  return { handleTagDashboard, openTagDialog, setOpenTagDialog };
};

export default useTagDashboardCollection;
